import LaunchIcon from "@mui/icons-material/Launch";
import { Box, InputLabel, Link } from "@mui/material";
import React from "react";

import { CodeBlock } from "components/common/CodeBlock/CodeBlock";
import { InlineCode } from "components/common/InlineCode/InlineCode";
import { getConfig } from "config/config";
import { SDK_BEGINNER_TUTORIAL_URL } from "config/constants";
import { Typography } from "new-components/typography/Typography";
import { isWindows } from "utils/operatingSystemUtils";

import { getSampleCode } from "../utils";


const { REACT_APP_BASE_PREFIX } = getConfig();

type SampleCodeSectionProps = {
  detectorId: string;
};

export function SampleCodeSection({ detectorId }: SampleCodeSectionProps) {
  const sampleCode = getSampleCode(detectorId);

  return (
    <Box>
      <InputLabel className="uppercase text-sm text-neutral-700 font-bold mb-2">sample code (python):</InputLabel>

      <Box sx={{ ml: { xs: '0px', md: '5px' }, mb: { xs: '10px', md: '8px' } }}>
        <Typography>To use this code:</Typography>

        <ul className="list-disc space-y-1 ml-7">
          <li>
            Make sure you have Python installed on your machine and a USB camera, integrated camera, or RTSP stream open
            on your network
          </li>

          <li>
            In the terminal, run
            <br />
            <InlineCode content="pip install groundlight" /> and <br />
            <InlineCode content="pip install framegrab" />
          </li>

          <li>
            Create a Groundlight API token{" "}
            <Link href={`${REACT_APP_BASE_PREFIX}/my-account/api-tokens`} className="no-underline font-medium">
              here
            </Link>
          </li>

          <li>
            Make your api token available to your program by running{" "}
            <InlineCode
              content={
                isWindows()
                  ? '$env:GROUNDLIGHT_API_TOKEN="YOUR_API_TOKEN_HERE"'
                  : "export GROUNDLIGHT_API_TOKEN=[Your_api_token_here]"
              }
            />
          </li>
        </ul>
      </Box>

      <CodeBlock content={sampleCode} />

      <Box className="my-5">
        <Link className="no-underline flex items-center gap-2" href={SDK_BEGINNER_TUTORIAL_URL} target="_blank">
          Read about more ways to integrate Groundlight into your application.{" "}
          <LaunchIcon className="text-primary-bright" />
        </Link>
      </Box>
    </Box>
  );
}
